export const ChevronDownIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:chevron-down">
			<path
				id="Vector"
				d="M17.4999 8.086L11.9999 13.586L6.49994 8.086L5.08594 9.5L11.9999 16.414L18.9139 9.5L17.4999 8.086Z"
				fill="#22082B"
			/>
		</g>
	</svg>
);
